import { LOGIN_PATH, NON_RETURNABLE_PATHS, REDIRECT_QUERY_PARAM, SIGN_OUT_REASON_QUERY_PARAM } from "@/constants/auth";
import { AuthSignOutReason } from "@/types/auth";
import type { RouteLocationRaw } from "vue-router";

function isReturnableTarget(target: string): boolean {
  if (!target.startsWith("/") || target.startsWith("//")) {
    return false;
  }

  const path = target.split(/[?#]/)[0];

  return !NON_RETURNABLE_PATHS.some((base) => path === base || path.startsWith(`${base}/`));
}

export function readRedirectTarget(value: unknown): string | null {
  if (typeof value !== "string" || !value) {
    return null;
  }

  return isReturnableTarget(value) ? value : null;
}

export function getCurrentRedirectTarget(): string | null {
  const { pathname, search, hash } = window.location;

  if (pathname === LOGIN_PATH) {
    return readRedirectTarget(new URLSearchParams(search).get(REDIRECT_QUERY_PARAM));
  }

  return readRedirectTarget(pathname + search + hash);
}

export function buildLoginQuery(target: string | null, reason?: AuthSignOutReason): Record<string, string> {
  const query: Record<string, string> = {};

  if (reason) {
    query[SIGN_OUT_REASON_QUERY_PARAM] = reason;
  }
  if (target) {
    query[REDIRECT_QUERY_PARAM] = target;
  }

  return query;
}

export function buildLoginPath(reason: AuthSignOutReason, target: string | null = getCurrentRedirectTarget()): string {
  const query = new URLSearchParams(buildLoginQuery(target, reason)).toString();

  return query ? `${LOGIN_PATH}?${query}` : LOGIN_PATH;
}

export function buildLoginLocation(target: string | null): RouteLocationRaw {
  return { name: "login", query: buildLoginQuery(target) };
}
